import { useTranslator } from '@gandi/translate';
import { Button } from '@gandi/ui';
import { pathjoin } from '@gandi/utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "Header-root_3KKYR",
  "buttonsContainer": "Header-buttonsContainer_3bKNo"
};
export function Header({
  adminURL,
  sharingId,
  order
}) {
  const {
    __
  } = useTranslator();
  return /*#__PURE__*/_jsxs("div", {
    className: styles.root,
    children: [/*#__PURE__*/_jsx("h2", {
      children: __('Summary of the order')
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.buttonsContainer,
      children: [/*#__PURE__*/_jsx(Button, {
        kind: "outline",
        to: pathjoin(adminURL, 'billing', sharingId, 'orders', order.id),
        children: __('View the order')
      }), !!order.invoice_id && !!order.invoice_num && /*#__PURE__*/_jsx(Button, {
        to: pathjoin(adminURL, 'billing', sharingId, 'invoices', order.invoice_id, order.invoice_num, 'pdf'),
        iconBefore: "download",
        children: __('Download the invoice')
      })]
    })]
  });
}